/**
 * Toggles the visibility of the search results container based on the input value.
 * If the input value is empty, the container is hidden and any "noResults" class is removed.
 * If the input value is "none", the container is shown with the "noResults" class.
 * Otherwise, the container is shown without the "noResults" class.
 * @param {HTMLInputElement} inputElement - The input element triggering the toggle.
 */

// TODO - Waitring for keystrokes to stop before triggering other presentaitonal behaviours

import { trapFocus } from "../helpers/trapFocus.js";
import { scrollElemTop } from "../helpers/scrollElemTop";

const toggleResultsContainer = (inputElement) => {
    let nextElement = inputElement.nextElementSibling;
    while (nextElement && !nextElement.classList.contains("search-results")) {
        nextElement = nextElement.nextElementSibling;
    }

    const nextDiv = nextElement;
    if (nextDiv) {
        trapFocus(nextDiv);
        const inputValue = inputElement.value.trim();

        if (inputValue === "") {
            nextDiv.setAttribute("hidden", "");
            nextDiv.classList.remove("noResults");
        } else {
            nextDiv.removeAttribute("hidden");

            if (inputValue === "none") {
                nextDiv.classList.add("noResults");
            } else {
                nextDiv.classList.remove("noResults");
            }
        }
    }
};

export const initSearchInputs = () => {
    const searchInputs = document.querySelectorAll('input[type="search"]');
    searchInputs.forEach((input) => {
        toggleResultsContainer(input);

        input.addEventListener("input", () => {
            toggleResultsContainer(input);
            scrollElemTop(input, 100);
        });
    });
};
